import React from 'react';
import cn from 'classnames';
import { Grid, GridItem } from 'components/UI/Grid';
import Card from './Card';

import * as styles from './TileIcons.module.scss';

export default function TileIcons({ tiles }) {
  return (
    <div className={cn(styles.wrapper, tiles.length > 6 && styles.scrollWrapper)}>
      <Grid md={{ cols: 2 }} lg={{ cols: 2 }} xl={{ cols: 2 }} gutterY="20px" gutterX="20px">
        {tiles.map(tile => (
          <GridItem key={tile.title} Tag="div">
            <Card {...tile} />
          </GridItem>
        ))}
      </Grid>
    </div>
  );
}
